'use strict'

angular
  .module('basalteApp')
  .constant('BAS_SCREEN', {
    SENSITIVITY_HIGH: 0,
    SENSITIVITY_MEDIUM: 1,
    SENSITIVITY_LOW: 2
  })
